<template>
  <setting-message-template-form
    :id="Number($route.params.id)"
    :confirm="confirm"
    @submit="update"
  />
</template>

<script>
import SettingMessageTemplateForm from '@/components/organisms/SettingMessageTemplateForm'

export default {
  components: { SettingMessageTemplateForm },
  props: {
    confirm: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    update (name, subject, body) {
      const params = { name, subject, body }
      this.$http.secured.put(`/company/entry/message/templates/${this.$route.params.id}`, params)
        .then(response => {
          this.$router.push({ name: 'settingMessageTemplates' })
        })
    }
  }
}
</script>
